import { Routes } from '@angular/router';
import { BlankComponent } from '@ukam/shell/layouts/blank/blank.component';
import { FullComponent } from '@ukam/shell/layouts/full/full.component';
import { authGuard } from '@ukam/shell/guards/auth.guard';

// Monta a árvore de rotas comum: as rotas de feature ficam sob o layout autenticado,
// e a autenticação sob o layout em branco. Cada app passa só as features que oferece
// e, opcionalmente, para onde a raiz ('/') deve redirecionar (ex.: 'loans/dashboard').
export function createAppRoutes(featureRoutes: Routes, homeRedirect?: string): Routes {
  return [
    {
      path: '',
      component: FullComponent,
      canActivateChild: [authGuard],
      children: [
        { path: '', redirectTo: homeRedirect ?? '', pathMatch: 'full' as const },
        ...featureRoutes,
      ],
    },
    {
      path: '',
      component: BlankComponent,
      children: [
        {
          path: 'authentication',
          loadChildren: () =>
            import('@ukam/auth/authentication.routes').then((m) => m.AuthenticationRoutes),
        },
      ],
    },
    {
      path: '**',
      redirectTo: '/',
    },
  ];
}
